import React from 'react'
import { Row, Separator } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'

export default function CenteredLoadingSpinner({ size = 'lg', separatorSize = 'xxl' }) {
  return (
    <>
      <Separator size={separatorSize} />
      <Row alignX="center">
        <NoticeLoading size={size} />
      </Row>
      <Separator size={separatorSize} />
    </>
  )
}
